// extracted by mini-css-extract-plugin
export var button = "_a7-0";
export var icon = "_a7-1";